export const LANGUAGE_OPTIONS = [

  {

    value: "es",

    label: "Español"

  },

  {

    value: "en",

    label: "Inglés"

  },

  {

    value: "fr",

    label: "Francés"

  }

];